"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Sparkles12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Size=12, Theme=Light" },
            react_1.default.createElement("path", { id: "Star big", d: "M1 6.46025C3.32622 6.17005 5.16991 4.32626 5.45995 2H5.5395C5.82957 4.32645 7.67352 6.17034 10 6.46032V6.53982C7.67357 6.82978 5.82964 8.67362 5.53952 11H5.45993C5.16984 8.6738 3.32617 6.83008 1 6.53989L1 6.46025Z", fill: "#5E30E3" }),
            react_1.default.createElement("path", { id: "Star small", d: "M8 1.98233C9.03387 1.85336 9.85329 1.03389 9.9822 0H10.0176C10.1465 1.03398 10.966 1.85349 12 1.98236V2.0177C10.966 2.14657 10.1465 2.96605 10.0176 4H9.98219C9.85326 2.96613 9.03385 2.1467 8 2.01773L8 1.98233Z", fill: "black" })));
}
function Sparkles12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Sparkles12Svg, Object.assign({}, svgProps)));
}
exports.default = Sparkles12;
//# sourceMappingURL=Sparkles12.js.map